<template>
  <div class="page-wrapper storybook-cnc-badge-dot">
    <StorybookTemplate title="CncBtnBackToTop" pathComponent="/shared/elements/global/v1/CncBtnBackToTop.vue" :propList="propList" :form.sync="form">
      <CncBtnBackToTop v-bind="form">{{ form.name }}</CncBtnBackToTop>
    </StorybookTemplate>
  </div>
</template>

<script>
export default {
  components: {
    StorybookTemplate: () => import('../../../../components/StorybookTemplate.vue')
  },
  data () {
    return {
      propList: [
        // { name: 'showLess', type: 'boolean', param: 'showLess' },
      ],

      form: {
        idElement: 'storybook-page',
        isShowBtn: true,
        isNotAction: true
      }
    }
  }
}
</script>
